import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Componentes
import { ChartPieComponent } from './chart-pie/chart-pie.component';
import { ChartBarComponent } from './chart-bar/chart-bar.component';
import { ChartColumnComponent } from './chart-column/chart-column.component';
import { TrendlineColumnComponent } from './trendline-column/trendline-column.component';
import { ChartPercentageBarComponent } from './chart-percentage-bar/chart-percentage-bar.component';
import { ChartSemicircleComponent } from './chart-semicircle/chart-semicircle.component';
import { ChartGroupedColumnComponent } from './chart-grouped-column/chart-grouped-column.component';

import './echarts.config';

@NgModule({
  declarations: [
    ChartPieComponent,
    ChartBarComponent,
    ChartColumnComponent,
    TrendlineColumnComponent,
    ChartPercentageBarComponent,
    ChartSemicircleComponent,
    ChartGroupedColumnComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    ChartBarComponent,
    ChartPieComponent,
    ChartColumnComponent,
    TrendlineColumnComponent,
    ChartPercentageBarComponent,
    ChartSemicircleComponent,
    ChartGroupedColumnComponent,
  ],
})
export class ChartsModule { }
